// removed by extract-text-webpack-plugin
module.exports = {"form":"src-components-Form----form-module---form---3On9E src-styles----index---container---1O8Oe src-styles----index---panel---2Guib","buttonWrapper":"src-components-Form----form-module---buttonWrapper---26Zak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/form.module.scss
// module id = 342
// module chunks = 168707334958949